
import { Component, Vue } from "vue-property-decorator";
import GeneralFooter from "@/components/general-footer.vue";
import { MY_JLS_TOKEN } from "@/constants/local-storage-keys";
import { Getter, Mutation } from "vuex-class";
import { ALLGEMEIN_ROUTE_NAME, LOGIN_ROUTE_NAME } from "@/router";

@Component({
  components: {
    GeneralFooter,
  },
})
export default class FormularAuswahl extends Vue {
  public logout(): void {
    if (localStorage.getItem(MY_JLS_TOKEN) !== null) {
      localStorage.removeItem(MY_JLS_TOKEN);
    }
    this.$router.push({ name: LOGIN_ROUTE_NAME });
  }

  public goToNextPage() {
    this.$router.push({ name: ALLGEMEIN_ROUTE_NAME });
  }

  @Getter("userName")
  username!: string;
}
